import { useMutation, useQueryClient } from '@tanstack/react-query';
import requestNewNumberBlock from 'API/Numbers/requestNewNumberBlock';
import { toast } from 'react-toastify';

const useRequestNewNumberBlock = (data, currentCompany, handleClose) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            try {
                const res = await requestNewNumberBlock({
                    currentCompany,
                    submitData: data,
                });
                if (res.status === 200) {
                    toast.success('New Number Block request success!');
                    handleClose();
                    return res;
                }
            } catch (error) {
                const errorMessage = `Failed to request New Number Block: ${error?.response?.data?.message || 'There are some field errors'}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['numbers'] });
        },
    });
};

export default useRequestNewNumberBlock;
